module.exports = __webpack_public_path__ + "img/yiliao6-1.5928040c.jpg";